import { render, staticRenderFns } from "./Yi.vue?vue&type=template&id=07e852db&scoped=true"
import script from "./Yi.vue?vue&type=script&lang=js"
export * from "./Yi.vue?vue&type=script&lang=js"
import style0 from "./Yi.vue?vue&type=style&index=0&id=07e852db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e852db",
  null
  
)

export default component.exports